var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SettingsPanelComponent } from '../settings-panel.component';
var AnalyticsSettingsComponent = /** @class */ (function (_super) {
    __extends(AnalyticsSettingsComponent, _super);
    function AnalyticsSettingsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnalyticsSettingsComponent.prototype.saveSettings = function (settings) {
        var payload = this.getPayload(settings || this.state.getModified());
        _super.prototype.saveSettings.call(this, payload);
    };
    AnalyticsSettingsComponent.prototype.getPayload = function (settings) {
        if (this.certificateFile) {
            settings.files = { certificate: this.certificateFile };
        }
        return settings;
    };
    AnalyticsSettingsComponent.prototype.setCertificateFile = function (files) {
        this.certificateFile = files.item(0);
    };
    return AnalyticsSettingsComponent;
}(SettingsPanelComponent));
export { AnalyticsSettingsComponent };
